export class Industry {
  industryId: string;
  industryName: string;

  loadFromJson(data: any) {
    this.industryId = data.industryId;
    this.industryName = data.industryName;
  }
}
